<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="标题"
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="类型"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.order_stat"
                  placeholder="支付状态"
                  width="50"
          >
            <el-option
                    v-for="item in settleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.referee_scale"
                  placeholder="类型"
                  width="50"
          >
            <el-option
                    v-for="item in settleOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="编号"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>

      <el-table-column
              label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.title}}
        </template>
      </el-table-column>
      <el-table-column
              label="会员特权"
      >
        <template slot-scope="scope">
          {{scope.row.title_details}}
        </template>
      </el-table-column>

      <el-table-column
        label="周期类型"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.card_type}}
        </template>
      </el-table-column>

      <el-table-column
        label="用户名称"
      >
        <template slot-scope="scope">
          {{scope.row.username}}
        </template>
      </el-table-column>
      <el-table-column
              label="用户微信头像"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.headimgurl!=null && scope.row.headimgurl!=''">
            <img :src= "getImgUrl3(scope.row)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="价格(元)"
      >
        <template slot-scope="scope">
          {{scope.row.price}}
        </template>
      </el-table-column>

      <el-table-column
              label="类型"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.referee_scale=='1'">
            会员卡
          </div>
          <div v-else-if="scope.row.referee_scale=='2'">
            油灯
          </div>
          <div v-else-if="scope.row.referee_scale=='3'">
            充值
          </div>
        </template>
      </el-table-column>



      <el-table-column
              label="下单时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_times}}
        </template>
      </el-table-column>

      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.order_stat=='0'">
            未支付
          </div>
          <div v-else-if="scope.row.order_stat=='1'">
            支付成功
          </div>
          <div v-else-if="scope.row.order_stat=='2'">
            支付失败
          </div>
        </template>
      </el-table-column>


    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>

  </d2-container>
</template>
<script>
import * as memberService from "@/api/sys/member";
import util from '@/libs/util.js'
export default {
  name: "MembergglPage",
  components: {  },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        dateRange: [],
        pickerOptions:{},
      settleOptions: [
        {
          value: "0",
          label: "未支付"
        },
        {
          value: "1",
          label: "支付成功"
        },

        {
          value: "2",
          label: "支付失败"
        }
      ],
      settleOptions2: [
        {
          value: "1",
          label: "会员卡"
        },
        {
          value: "2",
          label: "油灯"
        },

        {
          value: "3",
          label: "充值"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {

    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          dl_type: util.cookies.get('dl_type'),
          agentid: util.cookies.get('agentid'),
        start_time:this.dateConversion(this.dateRange[0]),
        end_time:this.dateConversion(this.dateRange[1]),
        xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        memberService.listMemberShUser(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    dateConversion(value) {
      if (value != null && value != "") {
        var d = new Date(value);
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.info("===========date=========" + date);
        return date;
      }else{
        return "";
      }
    },
    getImgUrl3(row){
      var good_url=row.headimgurl;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return good_url;
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      add() {
          this.agent = {};
          this.editFormVisible = true;
      },
    openEditForm(oneclass) {
      this.agent = oneclass;
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService
          .delMemberpriceBath({
            ids: this.multipleSelection.map(item => item.id).join()
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(oneclass) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService.delMemberprice({id:oneclass.id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
